import { render, staticRenderFns } from "./Radios.vue?vue&type=template&id=03ae1a20&scoped=true&"
import script from "./Radios.vue?vue&type=script&lang=js&"
export * from "./Radios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae1a20",
  null
  
)

export default component.exports